// Add this function near your other helper functions
export const getTextColor = (hexColor) => {
  if (!hexColor) return "#ffffff"; // Default to white if no color provided
  
  // Remove # if present
  hexColor = hexColor.replace("#", "");
  
  // Convert to RGB
  const r = parseInt(hexColor.substring(0, 2), 16);
  const g = parseInt(hexColor.substring(2, 4), 16);
  const b = parseInt(hexColor.substring(4, 6), 16);
  
  // Calculate relative luminance (perceived brightness)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  // Use black text for light colors, white for dark colors
  return luminance > 0.5 ? "#000000" : "#ffffff";
};

/**
 * A line colour light enough (Purple, Coral, Gold …) that text set in it reads
 * thinner and smaller than the same text in a dark line colour like Dk Blue.
 */
export const isLightLineColor = (hexColor) => {
  const hex = (hexColor || "").replace("#", "");
  if (!/^[0-9a-f]{6}$/i.test(hex)) return false;
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.3;
};


export const renderColorDotAndName = (hexCode, colorName) => {
  const hex = hexCode || "#000";
  const color = String(colorName || "").trim();
  if (!color) return null;

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "8px", lineHeight: 1 }}>
      <span
        style={{
          display: "inline-block",
          width: "7px",
          height: "7px",
          flexShrink: 0,
          borderRadius: "50%",
          backgroundColor: hex,
        }}
      />
      <span style={{ color: hex, lineHeight: 1 }}>{color}</span>
    </span>
  );
};

/**
 * Renders a name with a colored dot and color name
 * @param {string} name - The name to display
 * @param {string} hexCode - The hex color code for the dot and text
 * @param {string} colorName - The color name to display
 * @returns {JSX.Element} React component with name, colored dot, and color name
 */
export const renderNameWithColor = (name, hexCode, colorName) => {
  if (!name) return null;
  
  const hex = hexCode || '#000';
  const color = colorName || '';
  
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', lineHeight: 1, whiteSpace: 'nowrap' }}>
      <span style={{ color: hex, lineHeight: 1 }}>
        {name}
      </span>
      {color && (
        <>
          <span
            style={{
              display: 'inline-block',
              width: '7px',
              height: '7px',
              flexShrink: 0,
              borderRadius: '50%',
              backgroundColor: hex,
            }}
          />
          <span style={{ color: hex, lineHeight: 1 }}>
            {color}
          </span>
        </>
      )}
    </span>
  );
};